import Svg, { Path } from 'react-native-svg';

export function GoogleMark({ size = 20 }: { size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" accessibilityLabel="Google">
      <Path
        fill="#4285F4"
        d="M21.58 12.23c0-.71-.06-1.39-.18-2.04h-9.2v3.86h5.26a4.49 4.49 0 0 1-1.95 2.95v2.5h3.16c1.85-1.7 2.91-4.22 2.91-7.27Z"
      />
      <Path
        fill="#34A853"
        d="M12.2 21.77c2.64 0 4.85-.88 6.47-2.37L15.51 17c-.88.59-2 .94-3.31.94a5.7 5.7 0 0 1-5.35-3.94H3.58v2.58a9.77 9.77 0 0 0 8.62 5.19Z"
      />
      <Path
        fill="#FBBC05"
        d="M6.85 14a5.86 5.86 0 0 1 0-3.75V7.67H3.58a9.78 9.78 0 0 0 0 8.91L6.85 14Z"
      />
      <Path
        fill="#EA4335"
        d="M12.2 6.31c1.44 0 2.73.49 3.75 1.47l2.79-2.79A9.35 9.35 0 0 0 12.2 2.45a9.77 9.77 0 0 0-8.62 5.22l3.27 2.58A5.7 5.7 0 0 1 12.2 6.31Z"
      />
    </Svg>
  );
}
